export interface FieldTimeInputs {
  driveMinutesByDay: number[];
  faceSeconds?: number;
}

export interface FieldTimeSummary {
  activeDays: number;
  faceSeconds: number;
  fieldTimeSeconds: number;
}

// field = drive + face (seconds); active days = days with a trip
export const summarizeFieldTime = ({
  driveMinutesByDay,
  faceSeconds,
}: FieldTimeInputs): FieldTimeSummary => {
  const face = faceSeconds ?? 0;
  const driveSeconds = driveMinutesByDay.reduce((total, minutes) => total + (minutes || 0), 0) * 60;
  const fieldTimeSeconds = driveSeconds + face;

  return {
    activeDays: driveMinutesByDay.filter((minutes) => minutes > 0).length,
    faceSeconds: face,
    fieldTimeSeconds,
  };
};

export default summarizeFieldTime;
